import { useEffect, useState } from "react";
import { Layer, Source } from "react-map-gl/maplibre";
import { mapTileType } from "../../../utils/maps/MapConstants";
import {
  OVERLAY_LAYER_ANCHOR_ID,
  WEATHER_LAYER_ANCHOR_ID,
} from "../utils/mapStyle";
import { getMapTileLayerId, getMapTileSourceId } from "../utils/tileSources";

interface RasterTileLayerProps {
  id: mapTileType;
  url: string;
  opacity?: number;
  refreshInterval?: number;
}

const RasterTileLayer: React.FC<RasterTileLayerProps> = ({
  id,
  url,
  opacity = 1,
  refreshInterval = 0,
}) => {
  const [revision, setRevision] = useState(0);
  const sourceId = getMapTileSourceId(id);
  const layerId = getMapTileLayerId(id);

  useEffect(() => {
    if (!refreshInterval) {
      return undefined;
    }

    const timer = window.setInterval(
      () => setRevision((value) => value + 1),
      refreshInterval
    );
    return () => window.clearInterval(timer);
  }, [refreshInterval]);

  return (
    <Source
      key={`${sourceId}-${url}-${revision}`}
      id={sourceId}
      type="raster"
      tiles={[url]}
      tileSize={256}
      minzoom={0}
      maxzoom={20}
      attribution="© Microsoft Azure Maps"
    >
      <Layer
        id={layerId}
        type="raster"
        beforeId={
          id === "BASE" ? WEATHER_LAYER_ANCHOR_ID : OVERLAY_LAYER_ANCHOR_ID
        }
        paint={{
          "raster-opacity": opacity,
          "raster-fade-duration": 0,
        }}
      />
    </Source>
  );
};

export default RasterTileLayer;
